import { getIconProps, type IconProps } from '#types'

/**
 * Checked icon — checkmark inside a squircle.
 *
 * The success counterpart to {@link InfoIcon} / {@link ErrorIcon}, sharing their
 * squircle. Use for success status alongside those two; for a bare checkmark
 * (selection ticks, "Saved" affordances) use {@link CheckmarkIcon} instead.
 */
export function CheckedIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M12 20.25C13.8356 20.25 15.2596 20.1511 16.3701 19.9043C17.4721 19.6594 18.2191 19.279 18.749 18.749C19.279 18.2191 19.6594 17.4721 19.9043 16.3701C20.1511 15.2596 20.25 13.8356 20.25 12C20.25 10.1644 20.1511 8.74036 19.9043 7.62988C19.6594 6.52789 19.279 5.78091 18.749 5.25098C18.2191 4.72104 17.4721 4.34061 16.3701 4.0957C15.2596 3.84894 13.8356 3.75 12 3.75C10.1644 3.75 8.74036 3.84894 7.62988 4.0957C6.52789 4.34061 5.78091 4.72104 5.25098 5.25098C4.72104 5.78091 4.34061 6.52789 4.0957 7.62988C3.84894 8.74036 3.75 10.1644 3.75 12C3.75 13.8356 3.84894 15.2596 4.0957 16.3701C4.34061 17.4721 4.72104 18.2191 5.25098 18.749C5.78091 19.279 6.52789 19.6594 7.62988 19.9043C8.74036 20.1511 10.1644 20.25 12 20.25Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.98 10.01L10.88 14.98L9.02 12.72"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
